( function () {
	'use strict';

	/* @ngInject */
	function authService ( apiService, logger, Session, $q, ERROR_MSGS, $location, $window ) {
		var service;

		// get authentication via username and password
		// return a promise ( sessionToken and user info ) and store session token to local storage
		function getAuthentication ( username, password ) {
			var deferred = $q.defer();

			apiService.user.save( {
				'loginName' : username,
				'password'  : password
			}, function ( res ) {
				if ( res ) {
					Session.setCredentials( res.payload );
					service.getUserPermissions( res.payload );
					Session.setFirstTime();
					deferred.resolve( res.payload );
				}
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function getUserPermissions ( user ) {
			var deferred = $q.defer();

			apiService.getUserPermissions.get( {
				'userId' : user.data.PersonnelId
			}, function ( res ) {
				if ( res ) {
					Session.setUserPermissions( res );
					deferred.resolve( res );
				}
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( err );
			} );
		}

		function getCredentialsByToken ( token ) {
			var deferred  = $q.defer();

			token = token + '==';

			var tokenInfo = {
				'sessionToken' : token
			};

			apiService.tokenSessions.get( {
				'bearerToken' : token
			}, function ( res ) {
				if ( res ) {
					tokenInfo.data = res.credentials;

					// transform to number inorder to be consistent with getAuthentication payload
					tokenInfo.data.userId      = Number( tokenInfo.data.PersonnelId );
					tokenInfo.data.PersonnelId = Number( tokenInfo.data.PersonnelId );
					tokenInfo.data.ClientId    = Number( tokenInfo.data.ClientId );
					tokenInfo.data.LoginCount  = Number( tokenInfo.data.LoginCount );
					tokenInfo.data.RoleTypeId  = Number( tokenInfo.data.RoleTypeId );

					Session.setCredentials( tokenInfo );
					service.getUserPermissions( tokenInfo );
					Session.setFirstTime();
					deferred.resolve( tokenInfo );
				}
			}, function ( err ) {
				logger.error( 'Unable to fetch.', ''  );
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function checkUserLogin () {
			return ( Session.getCredentials() || {} ).LicenseAccepted;
		}

		function isViewOnlyMode () {
			return ( ( Session.getCredentials() || { } ).requestedUrl || '' ).indexOf( 'viewmode=true' ) > -1 || false;
		}

		function killSession ( checkReload, url ) {
			Session.destroyCredentials();
			Session.destroyFirstTime();
			Session.destroyUserPermissions();

			if ( !checkReload ) {
				$window.location = url || '/';
			}
		}

		function logout () {
			if ( ( Session.getCredentials() || { } ).sessionToken ) {
				apiService.tokenSessions.remove( {
					'bearerToken' : Session.getCredentials().sessionToken
				}, function () {
					killSession();
				}, function () {
					killSession();
				} );
			} else {
				$window.location = '/';
			}
		}

		service = {
			'isLogged'              : checkUserLogin,
			'isViewOnlyMode'        : isViewOnlyMode,
			'getAuthentication'     : getAuthentication,
			'getCredentialsByToken' : getCredentialsByToken,
			'logout'                : logout,
			'getUserPermissions'    : getUserPermissions,
			'killSession'           : killSession
		};

		return service;
	}

	// session as service
	function SessionService () {
		var self = this;

		function setCredentials ( res ) {
			var credentials = {
				'sessionToken' : res.sessionToken,
				'userId'       : res.data.PersonnelId
			};

			angular.extend( credentials, res.data );

			localStorage.setItem( 'credentials', JSON.stringify( credentials ) );
		}

		function getCredentials () {
			var credentials = localStorage.getItem( 'credentials' );

			if ( credentials ) {
				return JSON.parse( credentials );
			}
		}

		function updateCredentials ( obj ) {
			var  credentials = getCredentials();

			angular.extend( credentials, obj );

			localStorage.setItem( 'credentials', JSON.stringify( credentials ) );

			return getCredentials();
		}

		function destroyCredentials () {
			if ( getCredentials() ) {
				localStorage.removeItem( 'credentials' );
				localStorage.removeItem( 'jaspertoken' );
			}
		}

		// for later sprints one popouts per session
		function setFirstTime ( type, val ) {
			var firstTime = {
				'clearTime'      : true,
				'deleteTemplate' : true
			};

			if ( type ) {
				firstTime[ type ] = val;
			}
			// for later sprints one popouts per session
			localStorage.setItem( 'firstTime', JSON.stringify( firstTime ) );
		}

		function getFirstTime () {
			var firstTime = localStorage.getItem( 'firstTime' );

			if ( firstTime ) {
				return JSON.parse( firstTime );
			}
		}

		function destroyFirstTime () {
			localStorage.removeItem( 'firstTime' );
		}

		function setUserPermissions ( res ) {
			// TODO: add create observation permission here
			var permissions = {
				'createTemplate' : res.create
			};

			angular.extend( permissions, res.data );

			localStorage.setItem( 'permissions', JSON.stringify( permissions ) );
		}

		function getUserPermissions () {
			var permissions = localStorage.getItem( 'permissions' );

			if ( permissions ) {
				return JSON.parse( permissions );
			}
		}

		function destroyUserPermissions () {
			if ( getUserPermissions() ) {
				localStorage.removeItem( 'permissions' );
			}
		}

		self.setCredentials         = setCredentials;
		self.getCredentials         = getCredentials;
		self.updateCredentials      = updateCredentials;
		self.destroyCredentials     = destroyCredentials;
		self.setFirstTime           = setFirstTime;
		self.getFirstTime           = getFirstTime;
		self.destroyFirstTime       = destroyFirstTime;
		self.setUserPermissions     = setUserPermissions;
		self.getUserPermissions     = getUserPermissions;
		self.destroyUserPermissions = destroyUserPermissions;

		return self;
	}

	angular
		.module( 'app.core' )
		.factory( 'authService', authService )
		.service( 'Session', SessionService );
} )();
